
(function ($) {
    $(document).ready(function () {  
        // Height Screen
        const appHeight = () => {
            const header = document.getElementsByClassName('shopify-section--header');
            const doc = document.documentElement;
            doc.style.setProperty('--app-height', `${window.innerHeight}px`);
            // doc.style.setProperty('--header-height', `${heightHeader}px`);
        }
        window.addEventListener('resize', appHeight);
        appHeight();

        // Header mobile
        $('[aria-controls="header-search-popup"]').click(function() {
            $('.menu_opener button[data-drawer-id="sidebar-menu"][aria-expanded="true"]').click();
        });
        $('.Collapsible').find('.Collapsible__Button').each(function () {
          $(this).on('click', function () {
            $(this).parent().addClass('open_lvl')
          })
        })
        $('.Collapsible').find('.back_btn').each(function () {
          $(this).on('click', function () {
            $(this).parent().parent().removeClass('open_lvl')
          })
        })

        // Header minicart
        $('.cart-drawer-menu').click(function() {
            $('body').toggleClass('cart-drawer-open');

            headerMinicartEmpty(0);
            function headerMinicartEmpty(c) {
              setTimeout(() => {
                if ($('.rebuy-cart__flyout-empty-cart a, .rebuy-widget .rebuy-product-actions button.rebuy-button, .rebuy-cart button.rebuy-button.rebuy-cart__checkout-button').length) {
                    if (windowWidth > 1025) {
                        document.querySelectorAll(".rebuy-cart__flyout-empty-cart a, .rebuy-widget .rebuy-product-actions button.rebuy-button, .rebuy-cart button.rebuy-button.rebuy-cart__checkout-button").forEach((button) => {
                            button.addEventListener("pointermove", (e) => {                  
                                const rect = button.getBoundingClientRect();
                        
                                const x = e.clientX - rect.left;
                                const y = e.clientY - rect.top;
                        
                                gsap.to(button, {
                                    "--pointer-x": `${x}px`,
                                    "--pointer-y": `${y}px`,
                                    duration: 0.6,
                        
                                });
                        
                                gsap.to(button, {
                                    "--button-glow": "#fff",
                                    duration: 0.2,
                                });
                            });
                      
                        });
                    }
                } else {
                    headerMinicartEmpty(c + 1)
                };
              }, 1500);
            }
        });
        
        $(document).on("click",".cart-drawer button[is=dialog-close-button]",function() {
            $('.rebuy-cart__flyout-close').click();
        });
        
        // Header minicart quantity mobile
        headerMinicart();
        function headerMinicart() {
            $(document).on("click","label.quantity-selector-label",function() {
                $(this).parent('quantity-selector').toggleClass('active');
                $(this).next('ul.quantity-selector-select').slideToggle();
            });
            $(document).on("click","ul.quantity-selector-select li",function() {
                $(this).parents('quantity-selector').removeClass('active');
                $(this).parent('ul.quantity-selector-select').slideUp();
                var quantityValue = parseInt($(this).attr('value'));
                $(this).parents('quantity-selector').find('label.quantity-selector-label').text(quantityValue);
                $(this).parents('quantity-selector').find('.quantity-selector__input').val(quantityValue);
            });
            $(document).on("click",".cart-drawer ul.quantity-selector-select li",function() {
                var quantityValue = parseInt($(this).attr('value'));
                var datahref = $(this).parents('.quantity-selector').find('.quantity-selector__button-label').attr('data-href');
                var dataHrefQty = datahref + quantityValue;
                $(this).parents('.quantity-selector').find('.quantity-selector__button-label').attr('href', dataHrefQty);
                $(this).parents('.quantity-selector').find('.quantity-selector__button-label').simulateClick('click');
            });
            $(document).mouseup(function(e) {
                var container = $("quantity-selector.quantity-selector");
                if (!container.is(e.target) && container.has(e.target).length === 0) {
                    $('ul.quantity-selector-select').slideUp()
                }
            });
        }

        // Header Section
        $('.menu_opener button[data-drawer-id]').on('click', function () {
            $('.PageOverlay').toggleClass('is-visible');
            if ($(this).attr('aria-expanded') == 'false') {
                $(this).attr('aria-expanded', true);
            } else {
                $(this).attr('aria-expanded', false);
            }
            var sectionId = $(this).attr('data-drawer-id');
            if ($('#' + sectionId).attr('aria-hidden') == 'false') {
                $('#' + sectionId).attr('aria-hidden', true);
            } else {
                $('#' + sectionId).attr('aria-hidden', false);
            }
        });
        $('.header__secondary-nav a').click(function () {
            $('.menu_opener button').attr('aria-expanded', false)
            $('.SidebarMenu').attr('aria-hidden', true);
            $('.PageOverlay').removeClass('is-visible');
        });
        $('.PageOverlay, .Drawer__Close').on('click', function () {
            $('.menu_opener button').attr('aria-expanded', false)
            $('.SidebarMenu').attr('aria-hidden', true);
            $('.PageOverlay').removeClass('is-visible');
        });

        // Header Menu item hover
        $('li.header__primary-nav-item > details.header__menu-disclosure').hover(
            function () {
              if($('.Search[aria-hidden=false]').length > 0) {
                $('.close_search').click();
              }
            }, function () {
                // hide book
                $('.booking_form_section').removeClass('tooltip_drawer_open');
                $('.booking_form_section').addClass('tooltip_drawer_close');
                $(".locations_menu ").removeClass('open_lvl_block');
                setTimeout(() => {
                    $('.booking_form_section').removeClass('tooltip_drawer_close');
                }, 500);
                $('.booking_form_section').fadeOut();
            }
        );

        // Header Quantity product        
        $('.quantity').each(function () {
            var spinner = jQuery(this),
                input = spinner.find('input[type="number"]'),
                btnUp = spinner.find('.quantity-up'),
                btnDown = spinner.find('.quantity-down'),
                min = input.attr('min'),
                max = input.attr('max');

            btnUp.click(function () {
                var oldValue = parseFloat(input.val());
                if (oldValue >= max) {
                    var newVal = oldValue;
                } else {
                    var newVal = oldValue + 1;
                }
                spinner.find("input").val(newVal);
                spinner.find("input").trigger('change');
                const eventChange = new Event('change');
                spinner.find("input")[0].dispatchEvent(eventChange);
            });

            btnDown.click(function () {
                var oldValue = parseFloat(input.val());
                if (oldValue <= min) {
                    var newVal = oldValue;
                } else {
                    var newVal = oldValue - 1;
                }
                spinner.find("input").val(newVal);
                spinner.find("input").trigger('change');
                const eventChange = new Event('change');
                spinner.find("input")[0].dispatchEvent(eventChange);
            });

        });


        /**
         * Header Mega menu booking_form_section
         */
        $(".booking_form_btn").on("click", function () {
            $(this).parents('.booking_form_wrapper').find('.booking_form_section').fadeIn().addClass('tooltip_drawer_open');
        });
        $('.booking_form_section').on('click', '.close_btn_wrap', function () {
            $('.booking_form_section').removeClass('tooltip_drawer_open');
            $('.booking_form_section').addClass('tooltip_drawer_close');
            $(".locations_menu ").removeClass('open_lvl_block');
            setTimeout(() => {
                $('.booking_form_section').removeClass('tooltip_drawer_close');
            }, 500);
            $('.booking_form_section').fadeOut();
        });
        $('.booking_form_section').on('click', '.section_bg', function () {
            $('.booking_form_section').removeClass('tooltip_drawer_open');
            $('.booking_form_section').addClass('tooltip_drawer_close');
            $(".locations_menu ").removeClass('open_lvl_block');
            setTimeout(() => {
                $('.booking_form_section').removeClass('tooltip_drawer_close');
            }, 500);
            $('.booking_form_section').fadeOut();
        });

        /**
         * Header Mega menu product
         */
        $(document).on("click",".subscription_product_cont .popover__value-list button",function() {
            var val = $(this).attr('value');
            $(this).parents('.ProductForm__Variants').find('select.select_ct').val(val).change();
            var valSelected = $(this).parents('.ProductForm__Variants').find('select.no_sb.variant_select').val();
        });
        function waitForObjectInWindow(objectName) {
            return new Promise((resolve, reject) => {
            const intervalId = setInterval(() => {
                if (window[objectName]) {
                clearInterval(intervalId);
                resolve(window[objectName]);
                }
            }, 100);
            });
        }
    
        async function productSubscription() {
            const reChargeWidget = await waitForObjectInWindow('ReChargeWidget');
            const subscriptions = document.querySelectorAll('.subscription_product_cont');
    
            subscriptions.forEach((subscription, index) => {
            const productID = subscription.getAttribute('data-id');
            const place = subscription.getAttribute('data-place');
            subscription.setAttribute('data-index', index);
    
            if (window.innerWidth < 1025 && (place === 'modal2' || place === 'modal' || place === 'menu')) return;
    
            const config = {
                productId: parseInt(productID), // Required
                injectionParent: `.subscription_product_cont[data-index="${index}"] .subscription_product_wrap`, // The node that will have the widget injected in
                injectionMethod: 'prepend', // How will the widget be injected 
                selectors: {
                price: [`.subscription_product_cont[data-index="${index}"] .button_price_value`], // the selectors that will be updated based on subscription
                variant: [`.subscription_product_cont[data-index="${index}"] .variant_select`] // The variants to watch for to update the subscription prices
                }
            }
            const widget = reChargeWidget.createWidget(config);
    
            setTimeout(() => {
                const inputs = subscription.querySelectorAll(`.subscription_product_wrap input`);
                const selects = subscription.querySelectorAll(`.subscription_product_wrap select`);
                for (const input of inputs) {
                const newIndex = input.id + '_' + index;
                input.id = newIndex;
                input.closest('.rc-radio').querySelector('label').setAttribute('for', newIndex);
                }
    
                for (const select of selects) {
                const newIndex = select.id + '_' + index;
                select.id = newIndex;
                }
    
                jQuery(`.subscription_product_cont[data-index="${index}"] .subscription_product_wrap select`).each(function () {
                try {
                    jQuery(this).selectBoxIt({
                    autoWidth: false,
                    showEffect: "slideDown",
                    hideEffect: "slideUp",
                    dynamicPositioning: false,
                    showEffectOptions: "down",
                    showFirstOption: true,
                    isMobile: function isMobile() {
                        return false; // (/iPhone|iPod|iPad|Android|BlackBerry|Opera Mini|IEMobile/).test(navigator.userAgent);
                    }
                    }).mouseleave(function (e) {
                    e.stopPropagation();
                    });
                } catch (error) {
                    console.log(error);
                }
                });
    
                if (place === 'page') {
                    const rcPlans = subscription.querySelectorAll(`.subscription_product_wrap .rc-selling-plans`);
                    for (const rcPlan of rcPlans) {
                        const firstLink = document.createElement('div');
                        const secondLink = document.createElement('div');
                        firstLink.classList.add('subscription_tooltip_btn');
                        firstLink.setAttribute('data-target', 'tooltip_drawer_shipping');
                        firstLink.innerHTML = 'How subscriptions work?';
                        secondLink.classList.add('subscription_tooltip_btn');
                        secondLink.setAttribute('data-target', 'tooltip_drawer_coffee_roasting');
                        secondLink.innerHTML = 'How Much Coffee Should I Get?';
        
                        rcPlan.appendChild(firstLink);
                        rcPlan.appendChild(secondLink);
        
                        firstLink.addEventListener('click', openTooltip, false);
                        secondLink.addEventListener('click', openTooltip, false);
                    }
                }
            }, 1000);
            });
        }

        menuBtnInit();
        function menuBtnInit() {
            const menuBtns = document.querySelectorAll('.menu_close_btn');
            for (const menuBtn of menuBtns) {
                menuBtn.addEventListener('click', () => {
                    const dropDowns = document.querySelectorAll('details.details-dropdown-level2');
                    for (const dropDown of dropDowns) {
                        dropDown.setAttribute('aria-expanded', false);
                        dropDown.classList.remove('open');
                    }
                });
            }
        }

        jQuery.fn.simulateClick = function() {
            return this.each(function() {
                if('createEvent' in document) {
                    var doc = this.ownerDocument,
                        evt = doc.createEvent('MouseEvents');
                    evt.initMouseEvent('click', true, true, doc.defaultView, 1, 0, 0, 0, 0, false, false, false, false, 0, null);
                    this.dispatchEvent(evt);
                } else {
                    this.click(); // IE Boss!
                }
            });
        }
    });
})(jQuery);